(() => {
  const steppers = Array.from(document.querySelectorAll('[data-qty-stepper]'));
  if (steppers.length === 0) return;

  const MIN = 1;
  const MAX = 100;
  const cartForm = document.querySelector('form.cart-form');
  const updateButton = cartForm?.querySelector('button[name="update"]');
  let updateTimer;

  function scheduleCartUpdate() {
    if (!updateButton) return;
    window.clearTimeout(updateTimer);
    // 合併快速連點，並讓商品備註的 submit handler 先完成儲存。
    updateTimer = window.setTimeout(() => cartForm.requestSubmit(updateButton), 350);
  }

  cartForm?.addEventListener('submit', () => window.clearTimeout(updateTimer));

  /**
   * 把輸入值正規化成 MIN–MAX 之間的整數
   * @param {string|number} value
   * @param {number} fallback - 無法解析時使用的值
   * @returns {number}
   */
  function normalize(value, fallback = MIN) {
    const parsed = parseInt(String(value).replace(/[^\d]/g, ''), 10);
    if (Number.isNaN(parsed)) return fallback;
    return Math.min(MAX, Math.max(MIN, parsed));
  }

  steppers.forEach((stepper) => {
    const input = stepper.querySelector('[data-qty-input]');
    const list = stepper.querySelector('[data-qty-list]');
    const decrease = stepper.querySelector('[data-qty-decrease]');
    const increase = stepper.querySelector('[data-qty-increase]');
    if (!input || !list) return;

    let built = false;
    let committedValue = normalize(input.value);

    /** 第一次開啟時才建立 1–100 的選項，避免每列購物車都先塞 100 個節點 */
    function buildOptions() {
      if (built) return;
      const fragment = document.createDocumentFragment();
      for (let i = MIN; i <= MAX; i += 1) {
        const option = document.createElement('li');
        option.className = 'qty-stepper__option';
        option.setAttribute('role', 'option');
        option.dataset.value = String(i);
        option.textContent = String(i);
        fragment.appendChild(option);
      }
      list.appendChild(fragment);
      built = true;
    }

    function markSelected() {
      const current = normalize(input.value);
      list.querySelectorAll('.qty-stepper__option').forEach((option) => {
        const isSelected = Number(option.dataset.value) === current;
        option.setAttribute('aria-selected', String(isSelected));
        option.classList.toggle('is-selected', isSelected);
      });
    }

    function openList() {
      buildOptions();
      markSelected();
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      const selected = list.querySelector('.is-selected');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }

    function closeList() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function setValue(value, { close = false } = {}) {
      const nextValue = normalize(value, committedValue);
      input.value = String(nextValue);
      if (built) markSelected();
      if (close) closeList();
      if (nextValue !== committedValue && input.form === cartForm) scheduleCartUpdate();
      committedValue = nextValue;
    }

    input.addEventListener('focus', openList);
    input.addEventListener('click', openList);

    input.addEventListener('input', () => {
      // 打字途中不強制修正，只過濾非數字，避免輸入 10 時被卡在 1
      input.value = input.value.replace(/[^\d]/g, '');
      if (built) markSelected();
    });

    input.addEventListener('blur', () => {
      setValue(input.value);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeList();
      } else if (event.key === 'Enter') {
        // 明確使用更新鈕的 formaction，避免隱含送出走物流外掛改寫的 action。
        if (input.form === cartForm && updateButton) event.preventDefault();
        setValue(input.value, { close: true });
      } else if (event.key === 'ArrowDown' && list.hidden) {
        event.preventDefault();
        openList();
      }
    });

    list.addEventListener('mousedown', (event) => {
      // 用 mousedown 搶在 input 的 blur 之前，避免清單先被關掉而點不到
      const option = event.target.closest('.qty-stepper__option');
      if (!option) return;
      event.preventDefault();
      input.focus();
      setValue(option.dataset.value, { close: true });
    });

    decrease?.addEventListener('click', () => setValue(normalize(input.value) - 1, { close: true }));
    increase?.addEventListener('click', () => setValue(normalize(input.value) + 1, { close: true }));

    document.addEventListener('click', (event) => {
      if (!stepper.contains(event.target)) closeList();
    });
  });
})();
